'use strict';

import { API_URL } from '../config/apiConfig';
import { getStrategyDraftForInterrupt } from './strategyInterruptDraft';

/**
 * @param {import('react-router-dom').NavigateFunction} navigate
 * @param {string} locationPathname
 * @param {{ gameId: string, gameState?: object, yourTurn?: boolean, strategyId?: string }} matchPayload
 */
export async function interruptForPvpMatch(navigate, locationPathname, matchPayload) {
  if (!matchPayload.gameId) {
    throw new Error('interruptForPvpMatch: gameId is required');
  }

  if (locationPathname === '/strategy') {
    const draft = getStrategyDraftForInterrupt();
    if (draft && Array.isArray(draft.orders) && draft.orders.length > 0) {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('interruptForPvpMatch: token required to auto-save strategy draft');
      }
      const res = await fetch(`${API_URL}/save-strategy`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          name: draft.name,
          description: draft.description ?? '',
          is_private: draft.is_private === true,
          orders: draft.orders,
        }),
      });
      if (!res.ok) {
        const errBody = await res.json().catch(() => ({}));
        throw new Error(errBody.error || 'Failed to auto-save strategy draft before PvP match');
      }
    }
  }

  const selectedGeneral = localStorage.getItem('selectedGeneral') || '';
  const selectedAdvisor = localStorage.getItem('selectedAdvisor') || '';
  const strategyId =
    matchPayload.strategyId ||
    localStorage.getItem('selectedPvpStrategy') ||
    localStorage.getItem('selectedStrategy') ||
    '';

  navigate(`/battle/${matchPayload.gameId}`, {
    state: {
      strategyId,
      token: localStorage.getItem('token'),
      userId: localStorage.getItem('userId'),
      selectedGeneral,
      selectedAdvisor,
      gameState: matchPayload.gameState,
      yourTurn: matchPayload.yourTurn,
      fromPvpInterrupt: true,
    },
  });
}
